var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledSingleLayerCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24.4609C18.6274 24.4609 24 19.0884 24 12.4609C24 5.83352 18.6274 0.460938 12 0.460938C5.37258 0.460938 0 5.83352 0 12.4609C0 19.0884 5.37258 24.4609 12 24.4609ZM16.9005 10.7775C17.4436 10.2802 17.4806 9.43678 16.9833 8.89374C16.4859 8.35069 15.6425 8.31365 15.0995 8.811L10.1767 13.3196L8.90054 12.1508C8.35749 11.6534 7.51409 11.6905 7.01673 12.2335C6.51938 12.7766 6.55642 13.62 7.09946 14.1173L9.27616 16.1109C9.78579 16.5776 10.5676 16.5776 11.0772 16.1109L16.9005 10.7775Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledSingleLayerCheck);
export default __webpack_public_path__ + "static/media/filled-single-layer-check.22713fad9a03e1eaab42abd4a4cbdd97.svg";
export { ForwardRef as ReactComponent };